import Vue from 'vue'
import { api } from '@/services'

import {
  attachToResourceChecklist,
  uploadToS3Checklist,
  uploadLogoFileUrl,
  downloadLogoFileUrl
} from '@/services/upload/uploadService'

// verification ------------------------------------------------------------
const isHost = () => {
  const rolesStr = localStorage.getItem('access_roles') || ''
  const roles = rolesStr.split(',').map((role) => role.trim())

  return roles.includes('ROLE_HOST')
}
// -----------------------------------------------------------------------

// old stuff --------------------------------------------------------------
const realEstateSearch = '/admin/dashboard/realEstatesBySearchText'
const headers = { Authorization: localStorage.getItem('old_token') }
// -----------------------------------------------------------------------

const state = {
  realEstateList: [],
  isRealEstateSearching: false,
  currentRealEstate: {},
  isCompanyLogoUploading: false,
  realEstateLogoUrl: ''
}

const getters = {
  realEstateList: (state) => state.realEstateList,
  isRealEstateSearching: (state) => state.isRealEstateSearching,
  currentRealEstate: (state) => state.currentRealEstate,
  isCompanyLogoUploading: (state) => state.isCompanyLogoUploading,
  realEstateLogoUrl: (state) => state.realEstateLogoUrl
}

const actions = {
  async realEstateSearch({ commit, dispatch, rootState }) {
    commit('setIsRealEstateSearching', true)

    const defaultParams = {
      size: rootState.paginate.itemsPerPage,
      page: rootState.paginate.currentPage - 1,
    }

    const params = { ...defaultParams, ...rootState.filters.filters }

    try {
      const { data } = await api.get(realEstateSearch, { headers, params })
      commit('setRealEstateList', data)
    } catch (error) {
      dispatch('showErrorMessage', error.message)
    } finally {
      commit('setIsRealEstateSearching', false)
    }
  },

  async fetchCurrentRealEstate({ commit, dispatch }) {
    // adicionado verificação se é host
    // um usuário que é HOST e SERVICE PROVIDER pode criar agendamento
    // este método é chamado o que ocorre o erro de acesso negado
    // sendo assim, não é necessário buscar a imobiliária que está associada
    if (isHost()) return

    commit('setIsLoading', true)

    try {
      const { data } = await api.get(`/web/realEstate/current`)

      commit('setCurrentRealEstate', data)
      commit('setBalance', data.available_balance)
      commit('setCommittedBalance', data.committed_balance)
      commit('setMinAvailableBalance', data.show_available_balance_warning)
      dispatch('showAvailableBalance')
    } catch ({ data }) {
      dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsLoading', false)
    }
  },

  async updateRealEstateDetails({ commit, dispatch }, payload) {
    commit('setIsLoading', true)

    await api
      .put('/web/realEstate/updateDetails', payload)
      .then(() => {
        commit('closeAllModals')
        dispatch('fetchCurrentRealEstate')
        dispatch('showSuccessMessage', Vue.i18n.translate('profile.updateRealEstate.label.successMessage'))
      })
      .catch(({ data }) => {
        data?.errors && data?.errors?.length >= 1
          ? dispatch('showErrorMessage', data.errors[0].message)
          : dispatch('showErrorMessage', data.message)
      })
      .finally(() => commit('setIsLoading', false))
  },

  async fetchRealEstatesBySearchText({ commit, dispatch }, searchText) {
    if (!searchText) return

    try {
      const { data } = await api.get('admin/dashboard/realEstatesBySearchText', {
        params: {
          searchText
        }
      })

      commit('setRealEstateList', data)
    } catch ({ data }) {
      data?.errors && data?.errors?.length >= 1
        ? dispatch('showErrorMessage', data.erros[0].message)
        : dispatch('showErrorMessage', data.message)
    }
  },

  async uploadRealEstateLogo({ commit, dispatch }, files) {
    commit('setIsCompanyLogoUploading', true)

    for (const file of files) {
      try {
        const { data } = await uploadLogoFileUrl(file)
        const { signedUrl, externalFilename, filename, acl } = data

        await uploadToS3Checklist(signedUrl, file, acl, filename)
        await attachToResourceChecklist(
          {
            filename,
            externalFilename,
            size: file.size,
            sequence: 1,
          },
        )
      } catch (error) {
        commit('setIsCompanyLogoUploading', false)
        dispatch('showErrorMessage', error.message)
      } finally {
        commit('setIsCompanyLogoUploading', false)
      }
    }
  },

  async downloadRealEstateLogo({ commit, dispatch }) {
    commit('setRealEstateLogoUrl', null)

    try {
      const { data } = await downloadLogoFileUrl()
      commit('setRealEstateLogoUrl', data.signedUrl)
    } catch (error) {
      dispatch('showErrorMessage', error.message)
    }
  }
}

const mutations = {
  setRealEstateList(state, realEstateList) {
    state.realEstateList = realEstateList
  },

  setIsRealEstateSearching(state, status) {
    state.isRealEstateSearching = status
  },

  setCurrentRealEstate(state, currentRealEstate) {
    state.currentRealEstate = currentRealEstate
  },

  setIsCompanyLogoUploading(state, status) {
    state.isCompanyLogoUploading = status
  },

  setRealEstateLogoUrl(state, url) {
    state.realEstateLogoUrl = url
  },
}

export default {
  state,
  mutations,
  actions,
  getters,
}
